// extracted by css-extract-rspack-plugin
export default {"buttonGroup":"CopilotAgentModeButton-module__buttonGroup__FXiqR"};